import firebase from "firebase";
import "firebase/firestore";

// Initialize Firebase
var firebaseConfig = {
  apiKey: "AIzaSyBmv3bT7LCGqOop4iA9Q31VoQj_vDuYlKc",
  authDomain: "vuosikello-672a8.firebaseapp.com",
  databaseURL: "https://vuosikello-672a8.firebaseio.com",
  projectId: "vuosikello-672a8",
  storageBucket: "vuosikello-672a8.appspot.com",
  messagingSenderId: "702301471146",
  appId: "1:702301471146:web:5d04ddff7fb589a06b6bd3"
};
const firebaseApp = firebase.initializeApp(firebaseConfig);

// Export firestore database
export default firebaseApp.firestore();
